module.exports = __webpack_public_path__ + "img/electrocactus_logo.ba6d7f1c.png";